<template>
  <component
    :is="layoutComponent"
    :field="field"
    :errors="errors"
    :show-label="false"
  >
    <template slot="field">
      <div class="custom-control custom-checkbox">
        <input
          :id="field.attribute"
          v-model="fieldValue"
          :dusk="field.attribute"
          type="checkbox"
          class="custom-control-input"
          :class="errorClasses"
          :disabled="inputDisabled"
        />
        <label class="custom-control-label check-text" :for="field.attribute">
          {{ field.label || fieldLabel }}
        </label>
        <div v-if="hasError" class="invalid-feedback">
          {{ errorMessages }}
        </div>
      </div>
    </template>
  </component>
</template>

<script>
import { FormCheckboxField } from "stylemix-base";

export default {
  name: "FormCustomCheckboxField",
  extends: FormCheckboxField,
};
</script>
